module.exports = __webpack_public_path__ + "static/mural-8-41cc87226f0a6d64a4f19c563d9c2895.jpg";